import styled from '@emotion/styled';
import { Div, Span } from '../../layouts';

export const ResidentDiscountInfoStyle = styled(Div)`
    will-change: opacity, max-height;
    transition: opacity 200ms, max-height 200ms;
    opacity: 0;
    max-height: 0;
    max-width: 400px;
    position: absolute;
    border-radius: 8px;
    &.open {
        max-height: 200px;
        opacity: 1;
    }
`;

export const ResidentDiscountArrowStyle = styled(Span)`
    transform: rotate(0deg);
    transition: transform 200ms;
    &.open {
        transform: rotate(180deg);
    }
`;
